// extracted by mini-css-extract-plugin
export var equalColumn = "_hm-0";